<template>
  <vx-modal :title="$t('MODALS.dependencias.title')" width="65%">
    <template v-slot:body>
      <div id="div-dependence" class="contenedor px-5 pt-5 pb-4 vs-con-loading__container">
        <div class="marco-area border flex flex-row">
          <div class="dependencia flex flex-col justify-between" :class="{ 'order-last': typeRelated === 'Compuesta' }">
            <div class="setting-related px-3 py-3 overflow-auto">
              <component
                :key="count"
                v-if="!isComputed && !IsTypeNumber"
                :is="WichComponent"
                :index="indexQuestion"
                :label="label"
                v-model="answer"
                :answer="answer"
                :disabled="isDependence"
              ></component>

              <component
                :key="count"
                :mini="questionsByPage[indexQuestion].properties.minValue"
                :maxi="questionsByPage[indexQuestion].properties.maxValue"
                v-else-if="!isComputed && IsTypeNumber"
                :is="WichComponent"
                :index="indexQuestion"
                :label="label"
                v-model="answerNum"
                :answer="answerNum"
                :disabled="isDependence"
              ></component>

              <component
                :key="count"
                v-else-if="selectedQuestionComputed !== null && !IsTypeNumberCompound"
                :is="WichComponentCompound"
                :label="selectedQuestionComputed.label"
                v-model="answer"
                :answer="answer"
                :disabled="isDependence"
              ></component>

              <component
                :key="count"
                :mini="mini"
                :maxi="maxi"
                v-else-if="selectedQuestionComputed !== null && IsTypeNumberCompound"
                :is="WichComponentCompound"
                :label="selectedQuestionComputed.label"
                v-model="answerNum"
                :answer="answerNum"
                :disabled="isDependence"
              ></component>
            </div>
            <div class="border-top type-related px-3 py-3 flex justify-between">
              <div class="w-1/2">
                <label class="font-bold mb-3">{{ $t("MODALS.dependencias.typeRelated") }}</label>
                <ul class="centerx mt-3">
                  <li class="mb-3" v-if="!isInformative">
                    <vs-radio color="success" v-model="typeRelated" vs-value="Standar">{{
                      $t("MODALS.dependencias.standar")
                    }}</vs-radio>
                  </li>
                  <li>
                    <vs-radio color="success" v-model="typeRelated" vs-value="Compuesta">{{
                      $t("MODALS.dependencias.compuesta")
                    }}</vs-radio>
                  </li>
                </ul>
              </div>
              <div class="w-1/2" v-if="typeRelated === 'Compuesta'">
                <label class="font-bold mb-3">Condición:</label>
                <ul class="centerx mt-3" v-if="!typeRelatedInfo">
                  <li class="mb-3">
                    <vs-radio color="success" v-model="typeCondition" vs-value="AND">AND</vs-radio>
                  </li>
                  <li>
                    <vs-radio color="success" v-model="typeCondition" vs-value="OR">OR</vs-radio>
                  </li>
                </ul>
                <span class="block mt-2 font-bold italic" v-else>{{ conditionComputed }}</span>
              </div>
            </div>
            <div class="border-top btn-create-dependence px-3 pt-3 flex flex-col justify-around">
              <label class="text-center block">
                {{ $t("MODALS.dependencias.message") }}
              </label>
              <vs-button
                v-if="!isComputed"
                :disabled="disabledBtn"
                class="w-full"
                color="success"
                type="border"
                @click="createDependence()"
                >{{ $t("MODALS.dependencias.btnCreateDependency") }}</vs-button
              >

              <vs-button
                v-else
                :disabled="disabledBtnCompound"
                class="w-full"
                color="success"
                type="border"
                @click="createDependenceCompound()"
                >{{ $t("MODALS.dependencias.btnCreateDependency") }}</vs-button
              >
            </div>
          </div>
          <div
            class="questions flex flex-col"
            :class="{ 'border-left': typeRelated !== 'Compuesta', 'border-right': typeRelated === 'Compuesta' }"
          >
            <div class="field-search border-bottom mb-2">
              <div class="chat__profile-search flex p-4">
                <vs-input
                  icon-no-border
                  v-model.trim="searchQuestion"
                  icon="icon-search"
                  icon-pack="feather"
                  class="w-full mx-5 input-rounded-full"
                  :placeholder="$t('MODALS.dependencias.searchPlaceHolder')"
                />
              </div>
            </div>
            <div class="list-questions pt-4">
              <vs-tabs v-model="TAB">
                <vs-tab
                  :label="$t('MODALS.dependencias.tabQuestion')"
                  class="overflow-auto"
                  style="height: 340px"
                  @click="change_tab1()"
                >
                  <vs-checkbox v-if="!isComputed" v-model="isSelectAll" @change="SelectAllQuestions(isSelectAll)">
                    {{ $t("MODALS.dependencias.all") }}
                  </vs-checkbox>
                  <vs-divider />
                  <ul>
                    <li
                      class="cursor-pointer border-bottom pt-1 pb-2 px-2"
                      v-for="(contact, index) in filterQuestionSearch"
                      :key="index"
                    >
                      <vs-row class="mt-5">
                        <vs-col vs-type="flex" vs-align="flex-end" vs-w="10" vs-sm="12" class="text-left">
                          <div class="w-full">
                            <span class="block font-bold">
                              {{ contact.name }}
                            </span>
                            <p class="truncate">
                              {{ contact.label }}
                            </p>
                          </div>
                        </vs-col>
                        <vs-col
                          vs-type="flex"
                          vs-justify="flex-end"
                          vs-align="center"
                          vs-w="2"
                          vs-sm="12"
                          class="text-left"
                        >
                          <vs-checkbox
                            v-if="!isComputed"
                            v-model="selectedQuestions"
                            :vs-value="contact.name"
                          ></vs-checkbox>
                          <vs-radio
                            v-else
                            color="success"
                            v-model="selectedQuestionComputed"
                            :vs-value="contact"
                          ></vs-radio>
                          <!-- {{selectedQuestionComputed}} -->
                        </vs-col>
                      </vs-row>
                    </li>
                  </ul>
                </vs-tab>
                <vs-tab
                  :label="$t('MODALS.dependencias.tabDependencies')"
                  class="overflow-auto"
                  style="height: 340px"
                  @click="change_tab2()"
                >
                  <ListDependenceStandar
                    v-if="!isComputed"
                    :getFilterDependencies="getFilterDependencies"
                    @deleteDependence="deleteDependence"
                    @answer="getAnswerList"
                  ></ListDependenceStandar>

                  <ListDependenceCompound
                    v-if="isComputed"
                    @deleteDependenceCompound="deleteDependenceCompound"
                    @answerCompound="answerCompound"
                    :getFilterDependencies="getFilterDependencies"
                    :allQuestions="allQuestions"
                  ></ListDependenceCompound>
                </vs-tab>
              </vs-tabs>
            </div>
          </div>
        </div>
      </div>
    </template>
  </vx-modal>
</template>

<script type="text/javascript">
import { getAllQuestion, setQuestion } from "../../../indexDB/logic.js";
import {
  createDependence,
  createDependenceCompound,
  getDependencies,
  getDadQuestion
} from "../../../indexDB/dependencies.js";
import { mapState, mapMutations, mapActions } from "vuex";
import { Components } from "./components/exportComponents.js";
import ListDependenceStandar from "./components/list-dependence-standar.vue";
import ListDependenceCompound from "./components/list-dependence-compound.vue";
import mixin from "./mixin.js";
export default {
  components: { ...Components, ListDependenceStandar, ListDependenceCompound },
  async mounted() {
    await setQuestion();
    await this.resetData();
  },
  mixins: [mixin],
  data() {
    return {
      TAB: 0,
      searchQuestion: "",
      isSelectAll: false,
      count: 0,
      filterQuestionStandar: [],
      filterQuestionCompuesta: [],
      filterDependence: [],
      filterDependenceCompound: [],
      selectedQuestions: [],
      selectedQuestionComputed: null,
      typeRelated: "Standar",
      answer: "",
      typeCondition: "AND",
      answerNum: 0,
      isDependence: false,
      allQuestions: [],
      String_: [
        "default",
        "email",
        "barcode",
        "phone",
        "textarea",
        "password",
        "ipv4",
        "ipv6",
        "domain",
        "multiInput",
        "checktext",
        "QRReader"
      ],
      Multiple: ["multi", "multiOther"],
      Unique: ["radio", "radioOther", "standar", "switch", "gallery/camera", "gallery", "camera"],
      Number_: ["number", "currency"],
      Ranking_: ["ranking"],
      Slider_: ["slider"],
      conditionComputed: null
    };
  },
  methods: {
    ...mapActions("resource", ["getCreatedDependencies"]),
    ...mapMutations("resource", ["UPDATE_STATE"]),
    /**
     * Obtiene la lista de respuestas para las dependencias standard
     * @param {*} event
     */
    getAnswerList(event) {
      this.answer = "";
      // this.answerNum = this.questionsByPage[this.indexQuestion].properties.minValue;
      if (this.IsTypeNumber) this.answerNum = event;
      if (this.IsTypeMulti) {
        const array = event.split(",");
        this.answer = array;
      } else this.answer = event;
    },
    /**
     * Obtiene todas las preguntas del formulario.
     */
    async getAllQuestions() {
      const result = await getAllQuestion();
      this.allQuestions = [...result];
      const index = result.findIndex(question => question.name === this.questionsByPage[this.indexQuestion].name);
      const sliceDataStandar = result.slice(index + 1, result.length);
      const nameQuestion = this.questionsByPage[this.indexQuestion].name;
      const nameDad = await getDadQuestion(nameQuestion);
      const sliceCompuesta = result.slice(0, index).filter(question => question.name !== nameDad);
      const { dependencias, compound } = await getDependencies();
      this.filterQuestionStandar = sliceDataStandar.filter(question => !dependencias.includes(question.name));
      this.filterQuestionCompound(compound, sliceCompuesta);
    },
    async filterQuestionCompound(compound, sliceCompuesta) {
      this.filterQuestionCompuesta = sliceCompuesta.filter(question => this.ComponentsToCompound(question));
      if (compound[this.questionsByPage[this.indexQuestion].name]) {
        const { answers } = compound[this.questionsByPage[this.indexQuestion].name];
        const keys = answers.map(question => question.name);
        this.filterQuestionCompuesta = this.filterQuestionCompuesta.filter(question => !keys.includes(question.name));
      }
    },
    /**
     * Obtiene las dependencias standard.
     */
    async getDependencies() {
      const { simple } = await getDependencies();
      const dependencias = simple[this.questionsByPage[this.indexQuestion].name];
      for (let i in dependencias) {
        const element = this.allQuestions.find(question => question.name === i);
        dependencias[i].label = element.label;
      }

      this.filterDependence = dependencias || [];
    },
    /**
     * Obtiene las dependencias compuestas.
     */
    async getDependenciesCompound() {
      const { compound } = await getDependencies();
      if (compound[this.questionsByPage[this.indexQuestion].name]) {
        const { answers, type } = compound[this.questionsByPage[this.indexQuestion].name];
        this.conditionComputed = type;

        for (let i in answers) {
          const element = this.allQuestions.find(question => question.name === answers[i].name);
          answers[i].label = element.label;
          answers[i].inputType = element.inputType;
        }
        return (this.filterDependenceCompound = answers);
      }

      this.filterDependenceCompound = [];
      this.conditionComputed = null;
    },
    /**
     * Crea una depednecia standard
     */
    async createDependence() {
      try {
        this.$vs.loading({
          container: "#div-dependence",
          scale: 0.6
        });
        const index = this.allQuestions.findIndex(question => question.name === this.nameDad);

        for (let i in this.selectedQuestions) {
          const nameChild = this.selectedQuestions[i];

          let relatedness = "simple";
          let answer = "answer";
          if (this.WichComponent === "String_") relatedness = "simple";
          if (this.WichComponent === "Multiple") {
            relatedness = "multiple";
            answer = "answers";
          }
          const _answer = this.IsTypeNumber ? this.answerNum : this.answer;
          const related = {
            name: this.nameDad,
            question: index,
            relatedness: relatedness,
            [answer]: _answer
          };
          await createDependence(this.nameDad, nameChild, related);
        }
        await this.resetData();
        await this.getCreatedDependencies();
      } finally {
        this.$vs.loading.close("#div-dependence > .con-vs-loading");
        this.isSelectAll = false;
      }
    },
    /**
     * Crea una dependencia compuesta
     */
    async createDependenceCompound() {
      try {
        this.$vs.loading({
          container: "#div-dependence",
          scale: 0.6
        });

        const { compound } = await getDependencies();

        let getAnswers = [];
        if (compound[this.questionsByPage[this.indexQuestion].name]) {
          const { answers } = compound[this.questionsByPage[this.indexQuestion].name];
          getAnswers = answers;
        }

        const index = this.allQuestions.findIndex(question => question.name === this.selectedQuestionComputed.name);

        let relatedness = "simple";
        let answer = "answer";
        let _answer = this.answer;
        if (this.WichComponentCompound === "String_") relatedness = "simple";
        if (this.WichComponentCompound === "Multiple") {
          answer = "answers";
          relatedness = "multiple";
        }

        if (this.IsTypeNumberCompound) _answer = this.answerNum;

        const questionToAdd = {
          name: this.selectedQuestionComputed.name,
          relatedness: relatedness,
          [answer]: _answer,
          question: index
        };

        const related = {
          relatedness: "compound",
          type: this.typeCondition,
          answers: [...getAnswers, questionToAdd]
        };

        const nameQuestion = this.questionsByPage[this.indexQuestion].name;
        await createDependenceCompound(nameQuestion, related);
        await this.resetData();
      } finally {
        this.$vs.loading.close("#div-dependence > .con-vs-loading");
      }
    },
    answerCompound(event) {
      this.selectedQuestionComputed = event;
      this.answer = this.selectedQuestionComputed.answer || this.selectedQuestionComputed.answers;
      if (this.WichComponentCompound === "Multiple" || this.WichComponentCompound === "Unique") {
        const elemnt = this.allQuestions.find(question => question.name === this.selectedQuestionComputed.name);

        const optionsBoolean = [
          { value: true, text: "Sí" },
          { value: false, text: "No" }
        ];

        this.UPDATE_STATE({ key: "optionsDependencies", value: elemnt.options || optionsBoolean });

        if (typeof this.selectedQuestionComputed.answer === "string")
          return (this.answer = this.selectedQuestionComputed.answer);
        if (typeof this.selectedQuestionComputed.answer === "boolean")
          return (this.answer = this.selectedQuestionComputed.answer);
        else {
          const answer = this.selectedQuestionComputed.answer || this.selectedQuestionComputed.answers;
          return (this.answer = [...answer]);
        }
        this.count++;
      }
    },
    /**
     * Verifica que componentes pueden realizar una dependencia compuesta.
     * @param { Object } question
     */
    ComponentsToCompound(question) {
      return (
        question.type === "input" ||
        question.type === "choice" ||
        question.type === "boolean" ||
        question.type === "photo" ||
        question.type === "number"
      );
    },
    /**
     * Selecciona todas las preguntas que se agregaran a la dependencia
     * @param {Boolean} isSelectAll
     */
    SelectAllQuestions(isSelectAll) {
      console.log("isSelectAll isSelectAll isSelectAll ", isSelectAll);
      console.log("selectedQuestions ", this.selectedQuestions);

      if (isSelectAll) {
        this.selectedQuestions = this.filterQuestion.map(question => question.name);
      } else this.selectedQuestions = [];
    }
  },
  computed: {
    ...mapState("resource", ["indexQuestion", "questionsByPage", "activePopup", "optionsDependencies"]),
    question() {
      return this.questionsByPage[this.indexQuestion];
    },
    inputType() {
      return this.questionsByPage[this.indexQuestion].inputType;
    },
    label() {
      return this.questionsByPage[this.indexQuestion].label;
    },
    IsTypeNumber() {
      if (this.inputType === "number" || this.inputType === "currency") return true;
      return false;
    },
    IsTypeMulti() {
      if (this.inputType === "multi") return true;
      return false;
    },
    IsTypeNumberCompound() {
      if (
        this.selectedQuestionComputed.inputType === "number" ||
        this.selectedQuestionComputed.inputType === "currency"
      )
        return true;
      return false;
    },
    WichComponent() {
      this.count++;
      this.UPDATE_STATE({ key: "optionsDependencies", value: [] });
      if (this.String_.includes(this.inputType)) return "String_";
      if (this.Number_.includes(this.inputType)) return "Number_";
      if (this.Ranking_.includes(this.inputType)) return "Ranking_";
      if (this.Slider_.includes(this.inputType)) return "Slider_";

      if (this.Multiple.includes(this.inputType)) {
        this.UPDATE_STATE({ key: "optionsDependencies", value: this.questionsByPage[this.indexQuestion].options });
        return "Multiple";
      }

      if (this.Unique.includes(this.inputType)) {
        if (["radio", "radioOther"].includes(this.inputType)) {
          this.UPDATE_STATE({ key: "optionsDependencies", value: this.questionsByPage[this.indexQuestion].options });
        } else {
          this.UPDATE_STATE({
            key: "optionsDependencies",
            value: [
              { value: true, text: "Sí" },
              { value: false, text: "No" }
            ]
          });
        }
        return "Unique";
      }
    },
    WichComponentCompound() {
      this.count++;
      this.UPDATE_STATE({ key: "optionsDependencies", value: [] });
      if (this.selectedQuestionComputed !== null) {
        if (this.IsTypeNumberCompound) {
          if (this.selectedQuestionComputed.properties)
            this.answerNum = this.selectedQuestionComputed.properties.minValue;
          else this.answerNum = this.selectedQuestionComputed.answer;
        }

        if (this.String_.includes(this.selectedQuestionComputed.inputType)) return "String_";
        if (this.Number_.includes(this.selectedQuestionComputed.inputType)) return "Number_";
        if (this.Ranking_.includes(this.selectedQuestionComputed.inputType)) return "Ranking_";
        if (this.Slider_.includes(this.selectedQuestionComputed.inputType)) {
          if (this.selectedQuestionComputed.properties) {
            this.answer = this.selectedQuestionComputed.properties.minValue;
          } else this.answer = this.selectedQuestionComputed.answer;

          return "Slider_";
        }

        if (this.Unique.includes(this.selectedQuestionComputed.inputType)) {
          if (["radio", "radioOther"].includes(this.selectedQuestionComputed.inputType)) {
            this.UPDATE_STATE({ key: "optionsDependencies", value: this.selectedQuestionComputed.options });

            if (this.selectedQuestionComputed.hasOwnProperty("properties")) {
              if (this.selectedQuestionComputed.properties.default === "multi") return "Multiple";
            } else if (this.selectedQuestionComputed.hasOwnProperty("answers")) {
              return "Multiple";
            }
          } else {
            this.UPDATE_STATE({
              key: "optionsDependencies",
              value: [
                { value: true, text: "Sí" },
                { value: false, text: "No" }
              ]
            });
          }
          return "Unique";
        }

        if (this.Multiple.includes(this.selectedQuestionComputed.inputType)) {
          this.answer = [];
          this.UPDATE_STATE({ key: "optionsDependencies", value: this.selectedQuestionComputed.options });
          return "Multiple";
        }
      }
      return "";
    },
    mini() {
      if (this.selectedQuestionComputed.properties) {
        const elemnt = this.allQuestions.find(question => question.name === this.selectedQuestionComputed.name);
        if (this.IsTypeNumberCompound) return elemnt.properties.minValue;
      }
    },
    maxi() {
      if (this.selectedQuestionComputed.properties) {
        const elemnt = this.allQuestions.find(question => question.name === this.selectedQuestionComputed.name);
        if (this.IsTypeNumberCompound) return elemnt.properties.maxValue;
      }
    },
    nameDad() {
      return this.questionsByPage[this.indexQuestion].name;
    },
    disabledBtn() {
      if (this.IsTypeNumber) {
        if (this.selectedQuestions.length === 0) return true;
      } else {
        if (this.answer === null || this.answer === "") return true;
        if (this.selectedQuestions.length === 0) return true;
      }

      return false;
    },
    disabledBtnCompound() {
      if (this.IsTypeNumberCompound) {
        if (this.selectedQuestionComputed === null || this.selectedQuestionComputed === "") return true;
      } else {
        if (this.answer === null || this.answer === "") return true;
        if (this.selectedQuestionComputed === null || this.selectedQuestionComputed === "") return true;
      }

      return false;
    },
    isInformative() {
      const informative = ["label", "viewer", "subform", "datasource", "photo"];
      if (informative.includes(this.question.type)) {
        setTimeout(() => (this.typeRelated = "Compuesta"), 500);
        return true;
      }
      return false;
    },
    typeRelatedInfo() {
      return this.typeRelated === "Compuesta" && this.TAB === 1;
    }
  }
};
</script>
<style type="text/css" lang="scss">
@import "./style.css";
</style>
